'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeTypicalResponseTimeText = makeTypicalResponseTimeText;

var _makeCustomResponse = require('./makeCustomResponse');

var _makeStandardResponse = require('./makeStandardResponse');

function makeTypicalResponseTimeText() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      typicalResponseTime = _ref.typicalResponseTime;

  if (!typicalResponseTime) return undefined;

  var usingCustomResponse = typicalResponseTime.usingCustomResponse,
      standardResponse = typicalResponseTime.standardResponse,
      customResponseQuantity = typicalResponseTime.customResponseQuantity,
      customResponseUnit = typicalResponseTime.customResponseUnit;


  if (usingCustomResponse) {
    return (0, _makeCustomResponse.makeCustomResponse)({
      customResponseQuantity: customResponseQuantity,
      customResponseUnit: customResponseUnit
    });
  }

  return (0, _makeStandardResponse.makeStandardResponse)({ standardResponse: standardResponse });
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/typical-response-time/operators/makeTypicalResponseTimeText.js
// module id = 584
// module chunks = 2 3